const data = {
  contacts: [
    {
      kind: 'GitHub',
      name: 'GitHub',
      url: 'https://github.com/282Haniwa',
      image: 'assets/SocialIcons/GitHub-Mark-64px.png'
    },
    {
      kind: 'Twitter',
      name: 'Twitter',
      url: 'https://twitter.com/282haniwa',
      image: 'assets/SocialIcons/Twitter_Social_Icon_Circle_Color.png'
    }
  ],
  mail: {
    address: 'usuieng@gmail.com',
    image: 'assets/SocialIcons/Free_Mail_icon.png'
  }
}

export default data
